import {
  Box,
  Container,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { selectedStateHighwaysSubnetworkState } from '@transport-insights/uikit';
import Pagination from '../../components/Pagination';
import StateHighwaysPotholeRepairsReportHeader from './components/report-headers/StateHighwaysPotholeRepairsReportHeader';
// import StateHighwaysPotholeRepairsRoadCategoryTargets from './components/report-sections/StateHighwaysPotholeRepairsRoadCategoryTargets';
// import StateHighwaysPotholeRepairsNetworkOutcomeContracts from './components/report-sections/StateHighwaysPotholeRepairsNetworkOutcomeContracts';
import StateHighwaysPotholeRepairsRegions from './components/report-sections/StateHighwaysPotholeRepairsRegions';
import PrintablePdf from '../../components/PrintablePdf';
import { useStateHighwaysSubnetworks } from '../../context/reports-api-hooks';
import DataDisclaimer from '../../components/DataDisclaimer';

function StateHighwaysPotholeRepairs() {
  const printableRef = useRef();
  const { data: subnetworks } = useStateHighwaysSubnetworks();
  const selectedSubnetwork = useRecoilValue(selectedStateHighwaysSubnetworkState);
  const selectedSubnetworkName = selectedSubnetwork === '' ? 'All State Highways' : subnetworks?.find((subnetwork) => subnetwork.id === selectedSubnetwork)?.displayName;
  // Trend chart data
  // const trendQuarters = [...new Set(QUARTERS.map((x) => `${x.label} 2023/24`))].sort();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName={`${selectedSubnetworkName} State Highways Pothole Repairs`}
              pageTitle={`${selectedSubnetworkName}`}
              printableRef={printableRef}
              printableStyles=".sh-potholes-grid {
                  grid-template-columns: 1fr 2fr;
                }
                .sh-potholes-road-category-targets {
                  flex-direction: column;
                }
                .sh-potholes-road-category-targets > div {
                  margin-inline-start: 0!important;
                  margin-start: 0!important;
                  margin-top: 5mm!important;
                }
              "
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                The Government Policy Statement on land transport (GPS) for 2024-34 identifies network maintenance as a key strategic priority and specifically targets pothole repairs. One requirement is that REG publicly reports on pothole repairs for all Road Controlling Authorities (RCAs) as part of NZTA’s Performance and Efficiency Plan.
              </Text>
              <Text mb={4}>
                REG collects pothole repair information for RCAs on behalf of NZTA via the Transport Insights web portal. The pothole repair information is reported quarterly to the Minister of Transport as part of the NZTA Performance and Efficiency Plan reports.
              </Text>
              <Text>
                RCA results are made available in this page once the results are approved for release by the NZTA Board and the Minister of Transport.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <StateHighwaysPotholeRepairsReportHeader />
          {/* <StateHighwaysPotholeRepairsRoadCategoryTargets />}
            {/* <StateHighwaysPotholeRepairsNetworkOutcomeContracts /> */}
          <StateHighwaysPotholeRepairsRegions />
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default StateHighwaysPotholeRepairs;
